//
//
//
//
//
//
//
//

export default {
  name: 'BecomeTrusted',
  computed: {
    display () {
      return this.$store.getters['user/isClient'] && !this.$store.getters['user/getClient']?.trusted
    }
  }
}
